import React from 'react';
import { CTAButton, Modal, SecondaryCTAButton } from '@ovotech/element-v4';
import { confirmModalTitle } from '@/src/pages/MovingHome/components/ConfirmModal/utils/confirmModalTitle';
import { confirmModalContent } from '@/src/pages/MovingHome/components/ConfirmModal/utils/confirmModalContent';
import { formatMovingDate } from '@/src/pages/MovingHome/components/ConfirmModal/utils/formatMovingDate';
import { LoadingContent } from '@ovotech/energy-cx/dist/shared/core/components';
import { MovingDateValues } from '@/src/types/MoveOut';
import { AnalyticsClick } from '@ovotech/ui-tools';
import {
  HOME_MOVES_CONFIRM_MODAL_EDIT,
  HOME_MOVES_CONFIRM_MODAL_CONFIRM,
} from '@/src/constants/analytics-subjects';
import styles from './ConfirmModal.module.css';

export enum ConfirmModalVariant {
  QUOTES = 'QUOTES',
  END_CONTRACT = 'END_CONTRACT',
  NO_UK_ADDRESS = 'NO_UK_ADDRESS',
}

type ConfirmModalProps = {
  address?: string;
  movingDate?: MovingDateValues;
  variant: ConfirmModalVariant;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onEdit: () => void;
};

export const ConfirmModal = ({
  address,
  movingDate,
  variant,
  isLoading,
  onClose,
  onConfirm,
  onEdit,
}: ConfirmModalProps) => {
  const headerText = address ?? formatMovingDate(movingDate);
  const title = confirmModalTitle(address);
  const content = confirmModalContent(variant);
  const CTAText = address ? 'Edit address' : 'Edit date';

  return (
    <Modal title={title} isOpen={true} onClose={onClose}>
      <div className={styles.headerText}>{headerText}</div>
      <div>{content}</div>

      <div className={styles.buttonsGroup}>
        <AnalyticsClick
          name={HOME_MOVES_CONFIRM_MODAL_EDIT}
          properties={{
            variant,
          }}
        >
          <SecondaryCTAButton disabled={isLoading} onClick={onEdit}>
            {CTAText}
          </SecondaryCTAButton>
        </AnalyticsClick>
        <AnalyticsClick
          name={HOME_MOVES_CONFIRM_MODAL_CONFIRM}
          properties={{
            variant,
            hasAddress: !!address,
            movingDate: movingDate ? formatMovingDate(movingDate) : undefined,
          }}
        >
          <CTAButton
            onClick={async () => {
              onConfirm();
            }}
          >
            <LoadingContent loading={isLoading}>Confirm</LoadingContent>
          </CTAButton>
        </AnalyticsClick>
      </div>
    </Modal>
  );
};
